/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as eventService from '../services/eventService'
class MasterEventTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toastMsg: "",
      toastType: "",
            eventTemplate:{}
        };
    }
    componentDidMount(){
        eventService.getEventTemplate().then((res)=>{
            let  result = res.reduce(function (r, a) {
                r[a.eventType] = r[a.eventType] || [];
                r[a.eventType].push(a);
                return r;
            }, Object.create(null));
            this.setState({eventTemplate:result})
        })
    }
    findElemIndex(array, attr, value) { 
        for (var i = 0; i < array.length; i += 1) { 
            if (array[i][attr] === value) { 
                return i; 
            } 
        } 
        return -1; 
    } 
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    editData(event_type,market_type,name,value){
        let eventTemplate = this.state.eventTemplate
        let market_index = this.findElemIndex(eventTemplate[event_type],"marketType",market_type)
        eventTemplate[event_type][market_index][name] = value
        this.setState({eventTemplate:eventTemplate})
    }
    saveChanges(type){
        let body = this.state.eventTemplate[type]
        eventService.updateEventTemplate(body).then((res)=>{
            if(res.isSuccess){
                this.props.notify("Event Template Update Successfully!","success");
            } else {
                alert(res.title,"error")
            }
        })
    }
    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }
    render() {
        return (
            <body className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper">
                    <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
                        <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
                        <ul>
                            <li><a href="list-of-clients.html">List of Clients</a></li>
                            <li><a href="#">Market Analysis</a></li>
                            <li><a href="import-event.html">Import Event</a></li>
                            <li>
                                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                                <ul className="list-unstyled collapse" id="homeSubmenu" >
                                    <li><a href="#">Test 1</a></li>
                                </ul>
                            </li>
                            <li>
                                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                                <ul className="list-unstyled collapse" id="home1Submenu" >
                                    <li><a href="#">Test 1</a></li>
                                    <li><a href="#">Test 1</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">Master Event Template</h5>
                                    <div className="row mt-2">
                                        <div className="col-12 col-sm-12 col-md-12">                                            
                                            {Object.keys(this.state.eventTemplate).map((type,i)=>{
                                                let markets = this.state.eventTemplate[type]
                                                return (<div className="gray-box mb-3">
                                                <div className="d-flex">
                                                    <span className="series-title">{type}</span>
                                                    <button className="import-btn" onClick={()=>{this.saveChanges(type)}}>Save</button>
                                                </div>
                                                <div className="row">
                                                    {markets.map((mkt,j)=>{
                                                        return (<div className="col-12 col-sm-6 col-md-6 col-lg-3 mt-2 mt-box bor-r1">
                                                        <div className="text-center">
                                                            <span className="status-title">{mkt.marketType}</span>
                                                        </div>
                                                        <div className="text-center w-100 ">
                                                            <div className="w-48">
                                                                <span className="tit1">Min:</span>
                                                                <span><input type="number" value={mkt.minBet} onChange={(e)=>{this.editData(type,mkt.marketType,"minBet",parseFloat(e.target.value))}} className="form-control d-inline w-60" placeholder="100" /></span>
                                                            </div>
                                                            <div className="w-48">
                                                                <span className="tit1">Max:</span>
                                                                <span><input type="number" value={mkt.maxBet} onChange={(e)=>{this.editData(type,mkt.marketType,"maxBet",parseFloat(e.target.value))}} className="form-control d-inline w-60" placeholder="100000" /></span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">Max Profit:</span>
                                                                <span><input type="number" value={mkt.maxProfit} onChange={(e)=>{this.editData(type,mkt.marketType,"maxProfit",parseFloat(e.target.value))}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">Pot Limit:</span>
                                                                <span><input type="number" value={mkt.potLimit} onChange={(e)=>{this.editData(type,mkt.marketType,"potLimit",parseFloat(e.target.value))}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">MTP:</span>
                                                                <span><input type="number" value={!!mkt.mtp?mkt.mtp:0} onChange={(e)=>{this.editData(type,mkt.marketType,"mtp",parseFloat(e.target.value))}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">Check Volume:</span>
                                                                <span>
                                                                    <label className="checkboxx">
                                                                        <input type="checkbox" onChange={(e)=>{this.editData(type,mkt.marketType,"volume",mkt.volume === null?0:null)}} checked={mkt.volume !== null}  />
                                                                        <span className="checkmark1 mt-6"></span>
                                                                    </label>
                                                                </span>
                                                                <span>
                                                                    <input type="number" className="form-control d-inline w-55" value={mkt.volume} onChange={(e)=>{this.editData(type,mkt.marketType,"volume",parseFloat(e.target.value))}}  placeholder="100000" disabled={mkt.volume === null} />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">Allow Unmatch Bet:</span>
                                                                <span>
                                                                    <label className="checkboxx">
                                                                        <input type="checkbox" checked={mkt.allowLimitOrder} onChange={(e)=>{this.editData(type,mkt.marketType,"allowLimitOrder",!mkt.allowLimitOrder)}} />
                                                                        <span className="checkmark1 mt-6"></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className=" w-100 mt-1">
                                                            <div>
                                                                <span className="tit1">Bet Delay:</span>
                                                                <span><input type="number" className="form-control d-inline w-60" onChange={(e)=>{this.editData(type,mkt.marketType,"betDelay",parseFloat(e.target.value))}} value={mkt.betDelay} placeholder="5" /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )
                                                    })}
                                                    </div>
                                            </div>)
                                            })
                                            }                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MasterEventTemplate);